<div class="pb-4">
  <form #form="ngForm" (ngSubmit)="register(form)">
    <div class="form-group">
      <label class="text-{{theme.brightContrast}}">Full Name</label>
      <input type="text" id="name" name="name" class="form-control" autocomplete="given-name"
        placeholder="Enter your full name" ngModel required />
    </div>
    <div class="form-group">
      <label class="text-{{theme.brightContrast}}">E-mail</label>
      <input type="email" id="email" name="email" class="form-control" placeholder="Enter your e-mail" ngModel
        required />
    </div>
    <div class="form-group">
      <label class="text-{{theme.brightContrast}}">Password</label>
      <input type="password" id="password" name="password" autocomplete="new-password" class="form-control"
        placeholder="Enter your password" ngModel required />
    </div>
    <div class="form-group">
      <label class="text-{{theme.brightContrast}}">Repeat your password</label>
      <input type="password" id="confirm" name="confirm" autocomplete="new-password" class="form-control"
        placeholder="Repeat your password" ngModel required />
    </div>
    <br>
    <button [disabled]="form.invalid" class="btn btn-block btn-success" type="submit">Sign up</button>
  </form>
</div>